import { render } from "./PageTitle.vue?vue&type=template&id=03622147"
import script from "./PageTitle.vue?vue&type=script&lang=js"
export * from "./PageTitle.vue?vue&type=script&lang=js"

import exportComponent from "/home/glassplant/agi.co.jp/roots-prod/vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__